/**
 * Leadens skeden i Affärer – Pipeline, med färger. Delas av Pipeline-sidan
 * och kundprojektsidan. 'sandbox' är ett gammalt skede som visas som Demo.
 */
export const STAGES = [
  { key: 'identified',   label: 'Identifierad',    color: '#78909C', bg: '#ECEFF1', darkBg: '#546E7A' },
  { key: 'qualified',    label: 'Kvalificerad',     color: '#1565C0', bg: '#E3F2FD', darkBg: '#1565C0' },
  { key: 'demo',         label: 'Demo',             color: '#00897B', bg: '#E0F2F1', darkBg: '#00897B' },
  { key: 'proposal',     label: 'Offert',           color: '#FF6B00', bg: '#FFF3E0', darkBg: '#E64A19' },
  { key: 'negotiation',  label: 'Förhandling',      color: '#6A1B9A', bg: '#F3E5F5', darkBg: '#6A1B9A' },
  // Pilot/kampanj pågår: aktivt men inte vunnet – värdet räknas inte som intäkt
  { key: 'pilot',        label: 'Pilot',            color: '#3949AB', bg: '#E8EAF6', darkBg: '#3949AB' },
  { key: 'won',          label: 'Vunnen',           color: '#2E7D32', bg: '#E8F5E9', darkBg: '#2E7D32' },
  { key: 'lost',         label: 'Förlorad',         color: '#C62828', bg: '#FFEBEE', darkBg: '#C62828' },
  { key: 'dormant',      label: 'Vilande',          color: '#795548', bg: '#EFEBE9', darkBg: '#795548' },
];

export function stageInfo(key) {
  if (key === 'sandbox') return STAGES.find(s => s.key === 'demo') || STAGES[0];
  return STAGES.find(s => s.key === key) || STAGES[0];
}
